import { render, staticRenderFns } from "./Makbuz.vue?vue&type=template&id=15677e1c&"
import script from "./Makbuz.vue?vue&type=script&lang=js&"
export * from "./Makbuz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports